import { UDF_SET_FLAGS, UDF_SET_LOADING } from "../actions/userDefinedFlags.actions";

export interface FetchParam {
    scope: string;
    variable: string;
    metric_identifier: string;
    label?: string;
}

// A coach flag stores neither key — its config is a blank object — so both are optional.
export interface FlagConfig {
    condition?: string;
    fetch_params?: Record<string, FetchParam>;
}

// `logic` flags carry a condition the nightly pipeline evaluates; `coach` flags carry
// no condition at all and are tagged by hand, so their config is a blank {}.
export type UserDefinedFlagType = "logic" | "coach";

export interface UserDefinedFlag {
    id?: number;
    name: string;
    abbreviation: string;
    description?: string;
    config: FlagConfig;
    color: string;
    is_active: boolean;
    type: UserDefinedFlagType;
}

interface UserDefinedFlagsState {
    flags: UserDefinedFlag[];
    loading: boolean;
}

const initialState: UserDefinedFlagsState = {
    flags: [],
    loading: false,
};

export const userDefinedFlagsReducer = (state = initialState, action: any): UserDefinedFlagsState => {
    switch (action.type) {
        case UDF_SET_FLAGS:
            return { ...state, flags: action.payload };
        case UDF_SET_LOADING:
            return { ...state, loading: action.payload };
        default:
            return state;
    }
};
